module.exports = __webpack_public_path__ + "media/assets/svgs/linkedInIcon-d15568821350dbfce28bd7b85244edfd.svg";